// Файл BrowserLock.js

/**
 * Компонент подключает глобальные ограничения браузерных действий, не мешая редактируемым областям приложения.
 */

import { useEffect } from 'react';

import { eventHandlers } from './browserLockHandlers';



const BrowserLock = () => {
    useEffect(() => {
        document.body.style.userSelect = 'none';
        document.body.style.msUserSelect = 'none';
        document.body.style.mozUserSelect = 'none';

        eventHandlers.forEach(([event_name, handler]) => {
            document.addEventListener(event_name, handler);
        });

        return () => {
            eventHandlers.forEach(([event_name, handler]) => {
                document.removeEventListener(event_name, handler);
            });

            document.body.style.userSelect = '';
            document.body.style.msUserSelect = '';
            document.body.style.mozUserSelect = '';
        };
    }, []);

    return null;
};


export default BrowserLock;
